export enum UserType {
  ADMIN = 'admin',
  USER = 'user',
  DESIGNER = 'designer',
}

export enum SortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
  NONE = 'NONE',
}

export enum Placement {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  AUTO_END = 'auto-end',
}

export enum BookRole {
  COLLABORATOR = 'COLLABORATOR',
  REVIEWER = 'REVIEWER',
  AUTHOR = 'AUTHOR',
}

export enum BlockEnum {
  PARAGRAPH = 'PARAGRAPH',
  TITLE = 'TITLE',
  IMAGE = 'IMAGE',
  LAYOUT_IMAGE = 'LAYOUT_IMAGE',
  NONE = 'NONE',
  EMPTY = '',
  CAPTION = 'CAPTION',
  STICKER = 'STICKER',
  CLIP_ART = 'CLIP_ART',
  FRAMES = 'FRAMES',
  SHAPE = 'SHAPE',
  TEXT_BOX = 'TEXT_BOX',
  BACKGROUND = 'BACKGROUND',
  CHATTER = 'CHATTER',
  BLANK = 'BLANK',
  LAYER_PLACEHOLDER = 'LAYER_PLACEHOLDER',
}

export enum LayoutEnum {
  SINGLE_BLOCK = 'SINGLE_BLOCK',
  TWO_COLUMNS = 'TWO_COLUMNS',
  THREE_COLUMNS = 'THREE_COLUMNS',
  FOUR_COLUMNS = 'FOUR_COLUMNS',
  IMAGE_CAPTION = 'IMAGE_CAPTION',
  IMAGE_TITLE = 'IMAGE_TITLE',
  TWO_ROWS = 'TWO_ROWS',
  THREE_ROWS = 'THREE_ROWS',
  FOUR_ROWS = 'FOUR_ROWS',
  TWO_GRID = 'TWO_GRID',
  LAYOUT_11 = 'LAYOUT_11',
  LAYOUT_12 = 'LAYOUT_12',
  LAYOUT_13 = 'LAYOUT_13',
  LAYOUT_14 = 'LAYOUT_14',
  LAYOUT_15 = 'LAYOUT_15',
  LAYOUT_16 = 'LAYOUT_16',
  LAYOUT_17 = 'LAYOUT_17',
  LAYOUT_18 = 'LAYOUT_18',
  LAYOUT_19 = 'LAYOUT_19',
  LAYOUT_20 = 'LAYOUT_20',
  LAYOUT_21 = 'LAYOUT_21',
  LAYOUT_22 = 'LAYOUT_22',
  LAYOUT_23 = 'LAYOUT_23',
  LAYOUT_24 = 'LAYOUT_24',
  LAYOUT_25 = 'LAYOUT_25',
  LAYOUT_26 = 'LAYOUT_26',
  LAYOUT_27 = 'LAYOUT_27',
  LAYOUT_28 = 'LAYOUT_28',
  LAYOUT_29 = 'LAYOUT_29',
  LAYOUT_30 = 'LAYOUT_30',
  LAYOUT_31 = 'LAYOUT_31',
  LAYOUT_32 = 'LAYOUT_32',
  LAYOUT_33 = 'LAYOUT_33',
  LAYOUT_34 = 'LAYOUT_34',
  LAYOUT_35 = 'LAYOUT_35',
}

export enum BLockLayoutEnum {
  STICKER = 'STICKER',
}

export enum PagePosition {
  SINGLE_PAGE = 'SINGLE_PAGE',
  LEFT_PAGE = 'LEFT_PAGE',
  RIGHT_PAGE = 'RIGHT_PAGE',
}

export enum TemplateCategory {
  ANNIVERSARY = 'ANNIVERSARY',
  BABY_BOOK = 'BABY_BOOK',
  BIRTHDAY = 'BIRTHDAY',
  CALENDAR = 'CALENDAR',
  CHILDREN = 'CHILDREN',
  CHRISTMAS = 'CHRISTMAS',
  COLLAGE = 'COLLAGE',
  COOKBOOK = 'COOKBOOK',
  DESIGN_ARCHITECTURE = 'DESIGN_ARCHITECTURE',
  EVENT = 'EVENT',
  FASHION = 'FASHION',
  FOOD = 'FOOD',
  HEALTH = 'HEALTH',
  LIST = 'LIST',
  MEMOIR = 'MEMOIR',
  NATURE = 'NATURE',
  NEW_YEAR = 'NEW_YEAR',
  NOVEL = 'NOVEL',
  PARTY = 'PARTY',
  PHOTO_BOOK = 'PHOTO_BOOK',
  POETRY = 'POETRY',
  PORTFOLIO = 'PORTFOLIO',
  QUOTE = 'QUOTE',
  REMEMBRANCE = 'REMEMBRANCE',
  SCHOOL = 'SCHOOL',
  SPIRITUAL = 'SPIRITUAL',
  SPORT = 'SPORT',
  STORYBOOK = 'STORYBOOK',
  THANKYOU = 'THANKYOU',
  TRAVEL = 'TRAVEL',
  WEDDING = 'WEDDING',
  YEARBOOK = 'YEARBOOK',
}

export enum TemplateStyle {
  ABSTRACT = 'ABSTRACT',
  AESTHETIC = 'AESTHETIC',
  ANTIQUE = 'ANTIQUE',
  ART = 'ART',
  BLACK = 'BLACK',
  CASUAL = 'CASUAL',
  COLOR = 'COLOR',
  CUTE = 'CUTE',
  DIARY = 'DIARY',
  EDUCATION = 'EDUCATION',
  ELEGANT = 'ELEGANT',
  FORMAL = 'FORMAL',
  FREE = 'FREE',
  FUN = 'FUN',
  GRAFFITI = 'GRAFFITI',
  ILLUSTRATED = 'ILLUSTRATED',
  LOVE = 'LOVE',
  LUXURY = 'LUXURY',
  MINIMALIST = 'MINIMALIST',
  MODERN = 'MODERN',
  NEUTRAL = 'NEUTRAL',
  RETRO = 'RETRO',
  SCRAPBOOK = 'SCRAPBOOK',
  SIMPLE = 'SIMPLE',
  SOCIAL = 'SOCIAL',
  TRADITIONAL = 'TRADITIONAL',
  TRENDY = 'TRENDY',
  URBAN = 'URBAN',
  VINTAGE = 'VINTAGE',
}

export enum TemplatePallette {
  WRITTEN = 'WRITTEN',
  BEIGE = 'BEIGE',
  BLACK_WHITE = 'BLACK_WHITE',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
  COLORFUL = 'COLORFUL',
  CREAM = 'CREAM',
  EARTHY = 'EARTHY',
  GOLD = 'GOLD',
  GREEN = 'GREEN',
  GREY = 'GREY',
  IVORY = 'IVORY',
  NEUTRAL = 'NEUTRAL',
  PASTEL = 'PASTEL',
  PINK = 'PINK',
  RED = 'RED',
  SILVER = 'SILVER',
  VIBRANT = 'VIBRANT',
  YELLOW = 'YELLOW',
}

export enum TemplateType {
  DESIGNED_BOOK = 'DESIGNED_BOOK',
  LAYOUT_BOOK = 'LAYOUT_BOOK',
  DESIGNED_COVER = 'DESIGNED_COVER',
  LAYOUT_COVER = 'LAYOUT_COVER',
  DESIGNED_PAGE = 'DESIGNED_PAGE',
  LAYOUT_PAGE = 'LAYOUT_PAGE',
}

export enum ModalName {
  UserManagementDelete = 'UserManagementDelete',
  UserManagementRemind = 'UserManagementRemind',
  UserManagementEditUser = 'UserManagementEditUser',
  UserManagementAddUser = 'UserManagementAddUser',
  UserManagementSendInvite = 'UserManagementSendInvite',
  UserManagementEditBook = 'UserManagementEditBook',
  InviteContributor = 'InviteContributor',
  ImageLibrary = 'ImageLibrary',
  UploadModal = 'UploadModal',
  SelectContributor = 'SelectContributor',
  Visibility = 'Visibility',
  PreviewBook = 'PreviewBook',
  CreateBook = 'CreateBook',
  PexelsLibrary = 'PexelsLibrary',
  ImageDeleteConfirm = 'ImageDeleteConfirm',
  AddAddress = 'AddAddress',
  GDPRDataRequest = 'GDPRDataRequest',
  DeleteAccount = 'DeleteAccount',
  AddMessageModal = 'AddMessageModal',
  DeletePage = 'DeletePage',
  DeleteBookConfirm = 'DeleteBookConfirm',
  BookInfo = 'BookInfo',
  CheckoutBook = 'CheckoutBook',
  PlaceOrder = 'PlaceOrder',
  SmallDeviceWarning = 'SmallDeviceWarning',
  CreateTemplate = 'CreateTemplate',
  AboutTemplate = 'AboutTemplate',
  LibraryImageEditor = 'LibraryImageEditor',
  FolderDeleteConfirm = 'FolderDeleteConfirm',
  ReplaceImage = 'ReplaceImage',
  QRUploadModal = 'QRUploadModal',
  ImageEditor = 'ImageEditor',
  OrderDetail = 'OrderDetail',
}

export const mainContentBlock: BlockEnum[] = [
  BlockEnum.IMAGE,
  BlockEnum.PARAGRAPH,
  BlockEnum.TITLE,
  BlockEnum.CHATTER,
  BlockEnum.NONE,
  BlockEnum.EMPTY,
  BlockEnum.BLANK,
];

export const layerContentBlock: BlockEnum[] = [
  BlockEnum.STICKER,
  BlockEnum.CLIP_ART,
  BlockEnum.FRAMES,
  BlockEnum.TEXT_BOX,
  BlockEnum.SHAPE,
  BlockEnum.LAYOUT_IMAGE,
  BlockEnum.BACKGROUND,
  BlockEnum.LAYER_PLACEHOLDER,
];

export enum PoliciesTabsEnum {
  TERMS = 'TERMS',
  PRIVACY = 'PRIVACY',
}

export enum KeyEvent {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  CTRL_C = 'CtrlC',
  CTRL_V = 'CtrlV',
  CTRL_X = 'CtrlX',
  DELETE = 'Delete',
}

export enum ScalableType {
  NONE = 'NONE',
  BOTH = 'BOTH',
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
}

export enum NotifyType {
  INVITE_ACCEPTED = 'InviteAccepted',
}

export enum CoverDropType {
  FRONT = 'FRONT',
  BACK = 'BACK',
  SPREAD = 'SPREAD',
}
